import { stockCountEnteredFlags, stockInStockWasEntered } from './stockOnHand'

/** Every row in an uploaded stock-take file is a count, including an explicit 0. */
export const markStockRowsCounted = products =>
  (Array.isArray(products) ? products : []).map(product => ({
    ...product,
    ...stockCountEnteredFlags(true),
  }))

export const STOCK_TAKE_UNCOUNTED_PLACEHOLDER = '—'

export const isCountedStockTakeLine = line => stockInStockWasEntered(line)

/** Last-ordered pack hint only on unused conversion rows, not the pack they counted. */
export const shouldShowDuplicatePackWarning = line =>
  Boolean(line?.duplicateConversionPack) && !isCountedStockTakeLine(line)

/** Empty until they type. Counted 0 stays 0. */
export const countedStockInputValue = (line, displayQty) =>
  isCountedStockTakeLine(line) ? displayQty : null
